import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import Section from "../../atoms/Section"
import ImageTextMolecule from "../../molecules/ImageText/ImageTextMolecule"

import * as Utils from "./utils"
import { hasImageOrVideo } from "./media"
import { cloneDeep } from "lodash"
import { sectionTitleHasText } from "../../../utils/utils"

const ImageTextSection = props => {
  const normalizedProps = cloneDeep(props)

  const hasMedia = hasImageOrVideo(normalizedProps)

  const hasTextContent = sectionTitleHasText(normalizedProps.text)

  const {
    mediaPositioning,
    verticalPadding,
    textChild,
    // overlap,
    // conditionalProps,
    // customPadding,
  } = Utils.useMemoizedProps(normalizedProps)

  let layoutChangerStyles = {}

  if (
    normalizedProps.section.verticalPadding === "fullHeight" &&
    normalizedProps.mediaPositioning !== "floating"
  ) {
    layoutChangerStyles.height = { _: "100%", md: "100vh" }
  }

  const hideBg = normalizedProps.transparentBg === false ? true : false

  const isEmptySection = !hasTextContent && !hasMedia
  const isFitMedia = mediaPositioning === "fit"
  const isCropMedia = mediaPositioning === "crop"
  const isFullWidthMedia = isFitMedia || isCropMedia

  // Fit and crop should move section standard padding into the text container ONLY when media exists.
  // Text-only sections should keep the Section's StandardPadding.
  const shouldDisableStandardPadding =
    !isEmptySection && ((isFullWidthMedia && hasMedia) || hideBg)

  return (
    <Section
      {...normalizedProps.section}
      verticalPadding={verticalPadding}
      verticalText={normalizedProps.verticalText}
      /* Fit and crop move standard padding from the section to the text container */
      noStandardPadding={shouldDisableStandardPadding}
      openModalSectionById={normalizedProps?.openModalSectionById}
      customVerticalPadding={
        !isEmptySection && isFullWidthMedia && hasMedia
          ? -1
          : normalizedProps.section.customVerticalPadding
      }
      maxWidth={
        isFullWidthMedia && hasMedia ? "100%" : normalizedProps.section.maxWidth
      }
      margin={
        normalizedProps.section?.margin
          ? normalizedProps.section?.margin
          : "0px auto"
      } // setting transparent nav margin when feature is turned on
      hideBg={hideBg}
      /* data attributes kept for debug */
      data-image-text-section="true"
      data-text-only={!hasMedia ? "true" : "false"}
    >
      <ImageTextMolecule
        {...normalizedProps}
        textChild={textChild}
        align={normalizedProps.alignProp}
        layoutChangerStyles={layoutChangerStyles}
        isMarginBtwChildsAPixelValue={true}
        useTextOnlyTitleMaxWidth={true}
        eagerLoad={normalizedProps.eagerLoad} // when eagerLoad is true, SSR renders the hero image eagerly.
      />
    </Section>
  )
}

export default ImageTextSection

ImageTextSection.propTypes = {
  strapi_id: PropTypes.number.isRequired,
  section: PropTypes.shape(Section.strapiProps).isRequired,
}

export const query = graphql`
  fragment ImageTextSection on STRAPI__COMPONENT_SECTIONS_IMAGE_TEXT {
    strapi_id
    section {
      ...Section
    }
    button {
      ...Button
    }
    button2 {
      ...Button
    }
    imageOrVideo {
      ...ImageOrVideo
    }
    text {
      ...SectionTitle
    }
    card {
      ...Card
    }
    verticalText {
      ...VerticalText
    }
    socialLinks {
      ...SocialLink
    }
    socialLinkStyles {
      ...SocialLinkStyles
    }
    iconAttribute {
      ...IconAttribute
    }
    iconStyles {
      ...IconStyles
    }
    newsletter {
      ...Newsletter
    }
    child1Px
    layoutStyle
    alignProp
    location
    mediaLocation
    mediaAlignment
    mediaRatio
    mediaWidth
    useNewsletter
    xOffsetOverlap
    yOffsetOverlap
    mediaPositioning
    mediaPositioningOnMobile
    marginBtwChilds
    mobileMarginBtwChilds
  }
`
